import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  acknowledgedAt: () => new Date(),
  createdAt: () => new Date(),
  trackingNumber: () => faker.number.int().toString(),
});
